import * as ActionTypes from './constants';

export const defaultState = () => ({
  breakpoint: 'sm',
});

export function globalEvents(state = defaultState(), action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SET_BREAKPOINT:
      return { ...state, breakpoint: payload.breakpoint };
    default:
      return state;
  }
}
